import type { PriceListMtrRowData } from 'gql/graphql';

import { Checkbox } from '@consta/uikit/Checkbox';

interface ICellRenderCheckbox {
    checkedIds: Record<string, boolean>;
    handleChangeCheckbox: (row: PriceListMtrRowData) => ({ checked }: { checked: boolean }) => void;
    data: PriceListMtrRowData;
}

export const CellRenderCheckbox = (props: ICellRenderCheckbox) => {
    const { checkedIds, handleChangeCheckbox, data } = props;

    return (
        <div>
            <Checkbox
                className="CheckboxFocus"
                checked={checkedIds[data?.id]}
                onChange={handleChangeCheckbox(data?.id)}
            />
        </div>
    );
};

CellRenderCheckbox.displayName = 'CellRenderCheckbox';
